var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('Intro'),_c('Content'),_c('Customer'),_c('Edu'),_c('Partners'),_c('Program'),_c('Teachers'),_c('Who'),_c('Ceo'),_c('Culture'),_c('Inquiry'),_c('Footer'),_c('Quick')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }